import { render } from "./HandOver.vue?vue&type=template&id=72226eae"
import script from "./HandOver.vue?vue&type=script&lang=js"
export * from "./HandOver.vue?vue&type=script&lang=js"

import exportComponent from "F:\\2024-岗亭\\jxwx-carpark-duty\\jxwx-carpark-duty\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__